const CLOUD = 'dn5kf9pyx';                     // tu Cloud name
const BASE = `https://res.cloudinary.com/${CLOUD}/image/upload`;
const FOLDER_PATH = 'sofascore/sofascore_images';

export const getImgSrc = (img) => {
    // 1) Si es SofaScore, extraigo el ID y apunto a tu proxy
    const sofascoreMatch = img.match(/player\/(\d+)\/image/);
    if (sofascoreMatch) {
        const id = sofascoreMatch[1];
        const src = `${BASE}/f_auto,q_auto/${FOLDER_PATH}/${id}.jpg`;
        return src;
    }

    // 2) Si no, uso directamente la URL que venga
    return img;
};
